import { render, staticRenderFns } from "./VehicleStatis.vue?vue&type=template&id=5d1d4128&scoped=true&"
import script from "./VehicleStatis.vue?vue&type=script&lang=js&"
export * from "./VehicleStatis.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStatis.vue?vue&type=style&index=0&id=5d1d4128&lang=less&scoped=true&"
import style1 from "./VehicleStatis.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d4128",
  null
  
)

export default component.exports